module.exports = __webpack_public_path__ + "res/ic_add_video.b2042e1f72ffee1d8d4cea71bb9dba25.png";